/**
 * Precision-safe JSON parsing for permission bitmasks.
 *
 * The backend serializes account permission masks as JSON NUMBERS.
 * Since the mask grew past bit 53 (patient-engagement bits 54/55 and
 * newer), the value exceeds Number.MAX_SAFE_INTEGER and JSON.parse
 * silently corrupts it: 720296924798849007 parses as
 * 720296924798849024, which zeroes bits 0-11 (ACCOUNTS_GET,
 * ACCOUNT_USERS_GET, ...) and can flip other bits ON — so nav tabs
 * disappear and permission checks randomly pass or fail depending on
 * the account's exact mask.
 *
 * Fix: before parsing, wrap the known mask fields in quotes so they
 * survive as strings. Every consumer resolves masks through
 * `checkPermission` / `isRoutePermitted`, and both convert with
 * `window.BigInt(value)`, which accepts numeric strings natively.
 *
 * The real long-term fix is the backend serializing masks as strings
 * (JSON numbers above 2^53 are unsafe for every JS consumer); this
 * shim keeps the dashboard correct either way and is a no-op once the
 * backend switches.
 */

const PERMISSION_MASK_FIELDS_RE =
  /"(currentAccountPermissions|childAccountPermissions)"\s*:\s*(\d+)/g;

export const quotePermissionMasks = text =>
  text.replace(PERMISSION_MASK_FIELDS_RE, '"$1":"$2"');

const parsePermissionSafeJson = text => JSON.parse(quotePermissionMasks(text));

export default parsePermissionSafeJson;
